import { render, staticRenderFns } from "./job-report.page.vue?vue&type=template&id=805f355a"
import script from "./job-report.page.vue?vue&type=script&lang=js"
export * from "./job-report.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports